module.exports = __webpack_public_path__ + "static/media/movies.666e2431.svg";